import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
// react-app-polyfills must be always at the top!

import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import { App } from "./App";
import { reportWebVitals } from "./reportWebVitals";
import { AppContextProvider } from "./AppContextProvider";
import { I18nextProvider } from "react-i18next";
import { QueryClient, QueryClientProvider } from "react-query";
import { CookiesProvider } from "react-cookie";

import i18n from "./i18n";
import { ProvideAuth } from "./hooks/useAuth";
import { KeenContextProvider } from "./KeenContextProvider";

import { enableAllPlugins } from "immer";
import { StickyProvider } from "./hooks/useStikyMessage";

// --- LOGICA DI REDIRECT AGENTICA ---
const OLD_DOMAIN = "portfolios.trendrating.com";
const NEW_DOMAIN = "systematicgains.com";

const { hostname, pathname, search, hash } = window.location;

const isOldDomain = hostname === OLD_DOMAIN;
// Qualsiasi hostname che arrivi sulla home ("/") viene reindirizzato a
// NEW_DOMAIN; le altre route (es. /product) continuano a funzionare sul
// dominio di origine. Nota: se hostname è già NEW_DOMAIN, questo causa un
// redirect verso se stesso.
const isHome = pathname === "/";

if (isOldDomain) {
  // Esegue il redirect immediato preservando path, parametri e hash
  window.location.replace(`https://${NEW_DOMAIN}${pathname}${search}${hash}`);
} else if (isHome) {
  window.location.replace(`https://${NEW_DOMAIN}${search}${hash}`);
} else {
  // Esegue il resto del codice solo se non siamo sul dominio da reindirizzare

  enableAllPlugins(); // Fix IE11 issue

  // IE11 polyfill
  (function () {
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event: any, params: any) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined,
      };
      var evt = document.createEvent("CustomEvent");
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail,
      );
      return evt;
    }

    CustomEvent.prototype = window.Event.prototype;
    (window as any).CustomEvent = CustomEvent;
  })();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
        refetchOnWindowFocus: false,
      },
    },
  });

  ReactDOM.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <KeenContextProvider>
            <AppContextProvider>
              <ProvideAuth>
                <CookiesProvider>
                  <StickyProvider>
                    <App />
                  </StickyProvider>
                </CookiesProvider>
              </ProvideAuth>
            </AppContextProvider>
          </KeenContextProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </React.StrictMode>,
    document.getElementById("root"),
  );

  reportWebVitals();
}
